var map = {
	"./App": "3dfd",
	"./App.vue": "3dfd",
	"./assets/fonts/Verizon-bold.otf": "51a6",
	"./assets/fonts/Verizon-bold.ttf": "6521",
	"./assets/fonts/Verizon-bold.woff": "bf1b",
	"./assets/fonts/Verizon-bold.woff2": "9cab",
	"./assets/fonts/Verizon-regular.otf": "8ea4",
	"./assets/fonts/Verizon-regular.ttf": "f79f",
	"./assets/fonts/Verizon-regular.woff": "4b2e",
	"./assets/fonts/Verizon-regular.woff2": "831a",
	"./assets/images/DOOM-Slayer.png": "de49",
	"./assets/images/Divider.svg": "d74c",
	"./assets/images/Duffy-Background.png": "7986",
	"./assets/images/Duffy.png": "37b4",
	"./assets/images/Factoid-Horizontal.svg": "7593",
	"./assets/images/Factoid-Vertical.svg": "3f24",
	"./assets/images/Female-Gamer-Background.png": "b123",
	"./assets/images/Oval.svg": "2425",
	"./assets/images/Shale-Headshot.png": "aff5",
	"./assets/images/Shale-Quote-Background.jpg": "645e",
	"./assets/images/Tree-Overlay.png": "e1c0",
	"./assets/images/Video-Header-Placeholder.jpg": "3f16",
	"./assets/images/Video-Thumbnail.jpg": "98c3",
	"./assets/images/large-quotes.png": "a899",
	"./assets/images/minus.svg": "de59",
	"./assets/images/plus.svg": "5860",
	"./assets/images/vz_150_rgb_p.png": "6ce9",
	"./assets/logo.png": "cf05",
	"./assets/styles/_base.scss": "9c1b",
	"./assets/styles/_bootstrap-settings.scss": "f6d4",
	"./assets/styles/_bootstrap-stack.scss": "b294",
	"./assets/styles/_bootstrap_vars.scss": "1afb",
	"./assets/styles/_fonts.scss": "5ac6",
	"./assets/styles/_global.scss": "c48f",
	"./assets/styles/_typography.scss": "39d6",
	"./assets/styles/_vars.scss": "8e17",
	"./assets/styles/blade1.scss": "9050",
	"./assets/styles/blade2a.scss": "f1ee",
	"./assets/styles/blade2b.scss": "41ca",
	"./assets/styles/blade3.scss": "94ad",
	"./assets/styles/blade4.scss": "d2c6",
	"./assets/styles/blade5a.scss": "a8ee",
	"./assets/styles/blade5b.scss": "9b58",
	"./assets/styles/blade6.scss": "ea4e",
	"./assets/styles/main.scss": "2fb4",
	"./assets/svgs/5G-Icon.svg": "06c3",
	"./assets/svgs/Cloud-Icon.svg": "d0e1",
	"./assets/svgs/Divider.svg": "8398",
	"./assets/svgs/Network-Icon.svg": "d71a",
	"./assets/svgs/Zones-Icon.svg": "5a1f",
	"./assets/svgs/minus.svg": "d0de",
	"./assets/svgs/plus.svg": "db37",
	"./assets/videos/Developer-Looping-Background.mp4": "7647",
	"./assets/videos/Developer-Looping-Video.mp4": "daff",
	"./assets/videos/Gameplay_White_BG_-_Feb_4.mp4": "210e",
	"./assets/videos/Verizon_Bethesda_200113B_720p_1mbps.mp4": "95fb",
	"./assets/videos/Video-Header-Compressed.mp4": "e045",
	"./components/Blade1": "c681",
	"./components/Blade1.vue": "c681",
	"./components/Blade1a": "4b7d",
	"./components/Blade1a.vue": "4b7d",
	"./components/Blade2": "dcc1",
	"./components/Blade2.vue": "dcc1",
	"./components/Blade3": "6b52",
	"./components/Blade3.vue": "6b52",
	"./components/Blade4": "5237",
	"./components/Blade4.vue": "5237",
	"./components/Blade5": "ca1a",
	"./components/Blade5.vue": "ca1a",
	"./components/Blade6": "411b",
	"./components/Blade6.vue": "411b",
	"./components/Dropdown": "711b",
	"./components/Dropdown.vue": "711b",
	"./components/Factoid": "0941",
	"./components/Factoid.vue": "0941",
	"./components/Intro": "a380",
	"./components/Intro.vue": "a380",
	"./components/TranscriptModal": "3b2a",
	"./components/TranscriptModal.vue": "3b2a",
	"./components/blade2-sections/Blade2a": "bee0",
	"./components/blade2-sections/Blade2a.vue": "bee0",
	"./components/blade2-sections/Blade2b": "d940",
	"./components/blade2-sections/Blade2b.vue": "d940",
	"./components/blade5-sections/2020FeatureIcon": "2de0",
	"./components/blade5-sections/2020FeatureIcon.vue": "2de0",
	"./components/blade5-sections/Blade5a": "e656",
	"./components/blade5-sections/Blade5a.vue": "e656",
	"./components/blade5-sections/Blade5b": "e956",
	"./components/blade5-sections/Blade5b.vue": "e956",
	"./components/factoids/BandwidthSvg": "2722",
	"./components/factoids/BandwidthSvg.vue": "2722",
	"./components/factoids/LatencySvg": "0cf0",
	"./components/factoids/LatencySvg.vue": "0cf0",
	"./components/factoids/VideoSvg": "702e",
	"./components/factoids/VideoSvg.vue": "702e",
	"./helpers/blade1": "f41a",
	"./helpers/blade1.js": "f41a",
	"./helpers/blade2b": "1e25",
	"./helpers/blade2b.js": "1e25",
	"./helpers/blade4": "30b7",
	"./helpers/blade4.js": "30b7",
	"./helpers/blade5a": "1ff2",
	"./helpers/blade5a.js": "1ff2",
	"./helpers/blade6": "baa9",
	"./helpers/blade6.js": "baa9",
	"./helpers/bladeAnimations": "5b3d",
	"./helpers/bladeAnimations.js": "5b3d",
	"./helpers/inView": "ecfe",
	"./helpers/inView.js": "ecfe",
	"./main": "56d7",
	"./main.js": "56d7",
	"./store": "c0d6",
	"./store.js": "c0d6",
	"./views/Home": "bb51",
	"./views/Home.vue": "bb51"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a8ec";